import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Campo Grau hierárquico: combobox EDITÁVEL. Permite selecionar um dos graus predefinidos
// (na ordem oficial fornecida pelo catálogo) OU digitar livremente um grau que não conste
// na lista. Não obriga escolher da lista e NÃO adiciona o texto digitado ao catálogo global.
export function GrauInput({ value, onChange, opcoes = [], testid = "grau-input", label = "Grau hierárquico", className = "" }) {
  const listId = `${testid}-list`;
  const v = (value || "").trim();
  const near = v ? opcoes.find((it) => (it.nome || "").trim().toLowerCase() === v.toLowerCase() && (it.nome || "").trim() !== v) : null;

  return (
    <div className={`min-w-0 ${className}`}>
      {label !== null && <Label>{label}</Label>}
      <Input
        data-testid={testid}
        list={listId}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Selecione ou digite (ex.: SD, CAP, ASP. OF)"
        autoComplete="off"
        className="w-full"
      />
      <datalist id={listId}>
        {opcoes.map((it) => <option key={it.id || it} value={it.nome || it} />)}
      </datalist>
      {near && (
        <button
          type="button"
          data-testid={`${testid}-sugestao`}
          onClick={() => onChange(near.nome)}
          className="mt-1 text-xs text-primary hover:underline"
        >
          Já existe "{near.nome}" — usar esta?
        </button>
      )}
    </div>
  );
}
